/** First-visit language for a fan page: manual choice, else browser, else club default. */
export function pickInitialLocale(a: { manualChoice: string | null; navigatorLanguages: readonly string[]; enabled: string[]; clubDefault: string | null }): string {
  if (a.manualChoice && a.enabled.includes(a.manualChoice)) return a.manualChoice;
  for (const tag of a.navigatorLanguages) {
    const base = tag.toLowerCase().split('-')[0];
    if (a.enabled.includes(base)) return base;
  }
  if (a.clubDefault && a.enabled.includes(a.clubDefault)) return a.clubDefault;
  return a.enabled[0] ?? 'en';
}
